import { render } from "./Ticket.vue?vue&type=template&id=2ae339ea&scoped=true&ts=true"
import script from "./Ticket.vue?vue&type=script&lang=ts"
export * from "./Ticket.vue?vue&type=script&lang=ts"

import "./Ticket.vue?vue&type=style&index=0&id=2ae339ea&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae339ea"]])

export default __exports__